/* Custom Jewelry Request Form - Multi-step controller */
(function () {
  'use strict';

  function getHeaderOffset() {
    var fixed = document.querySelector('.shopify-section-header, .site-header, header.header, #shopify-section-header');
    if (fixed) {
      var rect = fixed.getBoundingClientRect();
      var pos = window.getComputedStyle(fixed).position;
      if (pos === 'fixed' || pos === 'sticky') return rect.height + 10;
    }
    return 20;
  }

  function scrollToWithOffset(el) {
    if (!el) return;
    var offset = getHeaderOffset();
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function init(root) {
    if (!root || root.dataset.cjfInit === '1') return;
    root.dataset.cjfInit = '1';

    var hero = root.querySelector('[data-cjf-hero]');
    var introPanels = Array.prototype.slice.call(root.querySelectorAll('[data-cjf-info]'));
    var formWrap = root.querySelector('[data-cjf-form-wrap]');
    var form = root.querySelector('[data-cjf-form]');
    if (!form) return;

    var backBtn = root.querySelector('[data-cjf-back]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-cjf-step]'));
    var stages = Array.prototype.slice.call(root.querySelectorAll('[data-cjf-stage]'));
    var endpoint = root.dataset.endpoint || '';
    var maxFiles = parseInt(root.dataset.maxFiles || '6', 10);
    var maxFileMB = parseInt(root.dataset.maxFileMb || '20', 10);
    var currentStepIdx = 0;
    var currentInfoIdx = -1; // -1 means hero; 0..n is info screens; then form
    var attachments = [];

    /* INTRO FLOW: hero → info screens → form ---------------------------- */
    function hideAllIntro() {
      if (hero) hero.style.display = 'none';
      introPanels.forEach(function (p) { p.classList.remove('is-active'); });
    }
    function showInfoPanel(idx) {
      hideAllIntro();
      if (formWrap) formWrap.hidden = true;
      currentInfoIdx = idx;
      if (idx < 0) {
        if (hero) hero.style.display = '';
        return;
      }
      if (idx >= introPanels.length) {
        startForm();
        return;
      }
      introPanels[idx].classList.add('is-active');
      introPanels[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function startForm() {
      hideAllIntro();
      if (formWrap) formWrap.hidden = false;
      currentInfoIdx = introPanels.length;
      showStep(0);
      formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* FORM STEPS -------------------------------------------------------- */
    function showStep(idx) {
      if (idx < 0 || idx >= steps.length) return;
      currentStepIdx = idx;
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      updateProgress();
      if (backBtn) backBtn.hidden = (idx === 0 && introPanels.length === 0);
      formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function updateProgress() {
      var activeStage = steps[currentStepIdx] ? parseInt(steps[currentStepIdx].dataset.stage, 10) : 0;
      stages.forEach(function (el) {
        var stageIdx = parseInt(el.dataset.cjfStage, 10);
        el.classList.toggle('is-active', stageIdx === activeStage);
        el.classList.toggle('is-done', stageIdx < activeStage);
      });
    }
    function validateStep(stepEl) {
      var requiredFields = stepEl.querySelectorAll('[data-required]');
      var ok = true;
      requiredFields.forEach(function (f) {
        var val = (f.value || '').trim();
        var errEl = stepEl.querySelector('[data-error-for="' + f.name + '"]');
        if (!val) {
          ok = false;
          if (errEl) errEl.textContent = 'This field is required';
        } else if (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
          ok = false;
          if (errEl) errEl.textContent = 'Please enter a valid email';
        } else if (f.type === 'tel' && val.replace(/\D/g, '').length < 7) {
          ok = false;
          if (errEl) errEl.textContent = 'Please enter a valid phone number';
        } else {
          if (errEl) errEl.textContent = '';
        }
      });
      var requireOneOf = stepEl.querySelector('[data-require-one]');
      if (requireOneOf) {
        var name = requireOneOf.dataset.requireOne;
        var anyChecked = stepEl.querySelector('input[name="' + name + '"]:checked');
        var errEl2 = stepEl.querySelector('[data-error-for="' + name + '"]');
        if (!anyChecked) {
          ok = false;
          if (errEl2) errEl2.textContent = 'Please choose an option';
        } else {
          if (errEl2) errEl2.textContent = '';
        }
      }
      // Multi-select with optional "not sure" escape hatch
      var requireMulti = stepEl.querySelector('[data-require-multi]');
      if (requireMulti) {
        var groupName = requireMulti.dataset.requireMulti;
        var notSureCb = stepEl.querySelector('[data-not-sure-for="' + groupName + '"]');
        var anyMulti = stepEl.querySelectorAll('input[name="' + groupName + '[]"]:checked').length > 0;
        var isNotSure = notSureCb && notSureCb.checked;
        var errEl3 = stepEl.querySelector('[data-error-for="' + groupName + '"]');
        if (!anyMulti && !isNotSure) {
          ok = false;
          if (errEl3) errEl3.textContent = 'Pick at least one option, or check "I\'m not sure"';
        } else {
          if (errEl3) errEl3.textContent = '';
        }
      }
      return ok;
    }
    function nextStep(stepEl) {
      if (!validateStep(stepEl)) return;
      if (currentStepIdx + 1 >= steps.length) return;
      showStep(currentStepIdx + 1);
    }
    function prevStep() {
      // If we're on first form step, go back to last info screen
      if (currentStepIdx === 0) {
        if (introPanels.length > 0) {
          if (formWrap) formWrap.hidden = true;
          showInfoPanel(introPanels.length - 1);
          return;
        }
      }
      if (currentStepIdx > 0) showStep(currentStepIdx - 1);
    }

    /* Single-select tiles ----------------------------------------------- */
    root.querySelectorAll('.cjf-option input[type=radio]').forEach(function (input) {
      input.addEventListener('change', function () {
        var name = input.name;
        root.querySelectorAll('input[name="' + name + '"]').forEach(function (other) {
          other.closest('.cjf-option').classList.toggle('is-selected', other.checked);
        });
      });
    });

    /* Multi-select tiles ------------------------------------------------ */
    root.querySelectorAll('.cjf-option input[type=checkbox]').forEach(function (input) {
      input.addEventListener('change', function () {
        var label = input.closest('.cjf-option');
        if (label) label.classList.toggle('is-selected', input.checked);

        // If this is part of a multi-select group, clear "I'm not sure" when something is picked
        var groupName = (input.name || '').replace(/\[\]$/, '');
        if (input.checked && groupName) {
          var notSureCb = root.querySelector('[data-not-sure-for="' + groupName + '"]');
          if (notSureCb && notSureCb.checked) {
            notSureCb.checked = false;
          }
        }
      });
    });

    /* "I'm not sure" checkbox clears the group when checked ------------- */
    root.querySelectorAll('[data-not-sure-for]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (!cb.checked) return;
        var groupName = cb.dataset.notSureFor;
        root.querySelectorAll('input[name="' + groupName + '[]"]').forEach(function (i) {
          if (i.checked) {
            i.checked = false;
            var label = i.closest('.cjf-option');
            if (label) label.classList.remove('is-selected');
          }
        });
      });
    });

    /* File upload ------------------------------------------------------- */
    var dropzone = root.querySelector('[data-cjf-dropzone]');
    var fileInput = root.querySelector('[data-cjf-fileinput]');
    var filesContainer = root.querySelector('[data-cjf-files]');

    function renderFiles() {
      if (!filesContainer) return;
      filesContainer.innerHTML = '';
      attachments.forEach(function (att, i) {
        var div = document.createElement('div');
        div.className = 'cjf-file';
        if (att.preview) {
          var img = document.createElement('img');
          img.src = att.preview;
          img.alt = att.name;
          div.appendChild(img);
        } else {
          var icon = document.createElement('div');
          icon.className = 'cjf-file__icon';
          icon.textContent = att.name;
          div.appendChild(icon);
        }
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'cjf-file__remove';
        rm.setAttribute('aria-label', 'Remove ' + att.name);
        rm.textContent = '×';
        rm.addEventListener('click', function () {
          attachments.splice(i, 1);
          renderFiles();
        });
        div.appendChild(rm);
        filesContainer.appendChild(div);
      });
    }
    function addFiles(fileList) {
      Array.prototype.slice.call(fileList).forEach(function (file) {
        if (attachments.length >= maxFiles) return;
        if (file.size > maxFileMB * 1024 * 1024) return;
        var entry = { file: file, name: file.name, preview: null };
        if (/^image\//.test(file.type)) {
          var reader = new FileReader();
          reader.onload = function (e) {
            entry.preview = e.target.result;
            renderFiles();
          };
          reader.readAsDataURL(file);
        }
        attachments.push(entry);
      });
      renderFiles();
    }
    if (fileInput) {
      fileInput.addEventListener('change', function (e) {
        addFiles(e.target.files);
        fileInput.value = '';
      });
    }
    if (dropzone) {
      dropzone.addEventListener('click', function () {
        if (fileInput) fileInput.click();
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) {
          e.preventDefault();
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
      });
    }

    /* Navigation buttons ------------------------------------------------ */
    root.querySelectorAll('[data-cjf-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepEl = btn.closest('[data-cjf-step]');
        nextStep(stepEl);
      });
    });
    root.querySelectorAll('[data-cjf-skip]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (currentStepIdx < steps.length - 1) showStep(currentStepIdx + 1);
      });
    });
    if (backBtn) backBtn.addEventListener('click', prevStep);

    root.querySelectorAll('[data-cjf-start]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        showInfoPanel(0); // first info screen, or start form if no info screens
      });
    });
    root.querySelectorAll('[data-cjf-info-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        showInfoPanel(currentInfoIdx + 1);
      });
    });
    root.querySelectorAll('[data-cjf-info-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (currentInfoIdx > 0) showInfoPanel(currentInfoIdx - 1);
        else { showInfoPanel(-1); }
      });
    });

    /* Submission --------------------------------------------------------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var lastStep = steps[steps.length - 1];
      if (!validateStep(lastStep)) return;
      submit();
    });

    function gatherPayload() {
      var gemSelections = [];
      form.querySelectorAll('input[name="gemstone[]"]:checked').forEach(function (i) { gemSelections.push(i.value); });
      var gemNotSure = form.querySelector('[data-not-sure-for="gemstone"]');
      return {
        jewelry_type: (form.querySelector('[name=jewelry_type]') || {}).value || '',
        gauge: (form.querySelector('[name=gauge]') || {}).value || '',
        length_diameter: (form.querySelector('[name=length_diameter]') || {}).value || '',
        material: ((form.querySelector('input[name=material]:checked') || {}).value) || '',
        gemstone: gemSelections.join(', '),
        gemstone_unsure: gemNotSure && gemNotSure.checked ? 'yes' : 'no',
        project_name: (form.querySelector('[name=project_name]') || {}).value || '',
        idea_description: (form.querySelector('[name=idea_description]') || {}).value || '',
        budget: ((form.querySelector('input[name=budget]:checked') || {}).value) || '',
        full_name: (form.querySelector('[name=full_name]') || {}).value || '',
        email: (form.querySelector('[name=email]') || {}).value || '',
        phone: (form.querySelector('[name=phone]') || {}).value || ''
      };
    }
    function submit() {
      var submitBtn = form.querySelector('[data-cjf-submit]');
      var errBanner = root.querySelector('[data-cjf-error]');
      if (errBanner) errBanner.hidden = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }
      var payload = gatherPayload();
      var formData = new FormData();
      Object.keys(payload).forEach(function (k) { formData.append(k, payload[k]); });
      attachments.forEach(function (att, i) {
        formData.append('attachment_' + i, att.file, att.name);
      });
      if (!endpoint) {
        console.warn('[CJF] No endpoint configured. Payload:', payload, 'Files:', attachments);
        showSuccess();
        return;
      }
      fetch(endpoint, { method: 'POST', body: formData })
        .then(function (res) {
          if (!res.ok) throw new Error('Submission failed (' + res.status + ')');
          return res.json().catch(function () { return {}; });
        })
        .then(function () { showSuccess(); })
        .catch(function (err) {
          if (errBanner) {
            errBanner.hidden = false;
            errBanner.textContent = err.message || 'Something went wrong. Please try again or email support@freshtrends.com.';
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Request';
          }
        });
    }
    function showSuccess() {
      var successEl = root.querySelector('[data-cjf-success]');
      if (!successEl) return;
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      successEl.classList.add('is-active');
      formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function bootstrap() {
    document.querySelectorAll('[data-cjf-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
